
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"45","height":"45"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"edit_big","d":"M38.283 1.51l5.127 5.126a5 5 0 010 7.07L16.063 41.054c-.316.316-.71.542-1.143.653L3.25 44.714a2.5 2.5 0 01-3.045-3.045L3.213 30c.112-.432.337-.827.653-1.143L31.212 1.509a5.001 5.001 0 017.071 0zM28.66 7.596L5.634 30.623l-3.008 11.67 11.67-3.008L37.32 16.26l-8.66-8.663zm4.32-4.32L30.428 5.83l8.66 8.661 2.554-2.552a2.501 2.501 0 000-3.536l-5.126-5.126-.236-.208a2.501 2.501 0 00-3.3.208z"}})]),_c('use',{attrs:{"fill":"#C5CDE2","fill-rule":"nonzero","xlink:href":"#edit_big","transform":"translate(.042)"}})])
          )
        }
      }
    